module.exports = {
	events: {
		news: {
			type: 'click',
			action: function(event){
				var self = event.data.component;

				if(
					(self.model.teaserAction || {}).data === 'news' &&
					self.model.gridNavigator &&
					self.model.routePath
				){
					self.model.gridNavigator.to(self.model.routePath);
				} else if(self.model.pdfLink) {
					window.location.href = self.model.pdfLink;
				}
			}
		}
	},

	methods: {
		prepare: function(){
			this.model.pdfLink = ((this.model.pdfFile || [])[0] || {}).url || '';
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;

			if(!self.model.gridNavigator){
				self.closest('layouts_gridNavigator_gridNavigator', function(gridComponent){
					self.model.gridNavigator = gridComponent;
				});
			}
		}
	}
}